import React, {Component} from 'react'


export default class PeaceMenu extends Component {

    constructor() {
        super()
        this.state = {
            menu : ''
        }
    }

    menuFx = (e) => {
        this.props.menu(e.target.id)
        this.setState(
            { menu : e.target.id }
        )
    }


    render() {

        return (
        	
            <React.Fragment>

                <div className='PeaceMenu' style={{zIndex: '1'}}>
                    <span id='relax' onClick={this.menuFx} style={{opacity: this.state.menu === 'relax' ? 1 : 0.5}}>Relax</span>
                    <span id='heal' onClick={this.menuFx} style={{opacity: this.state.menu === 'heal' ? 1 : 0.5}}>Heal</span>
                    <span id='focus' onClick={this.menuFx} style={{opacity: this.state.menu === 'focus' ? 1 : 0.5}}>Focus</span>
                </div>

            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/peace/PeaceMenu.js